import theme from 'presentation/styles/theme'
import React, {
  AnchorHTMLAttributes,
  ButtonHTMLAttributes,
  forwardRef,
  ForwardRefRenderFunction
} from 'react'
import * as S from './styles'

type ButtonTypes =
  | AnchorHTMLAttributes<HTMLAnchorElement>
  | ButtonHTMLAttributes<HTMLButtonElement>

export type ButtonProps = {
  as?: React.ElementType
  variant?: 'default' | 'text'
  type?: 'button' | 'submit'
  size?: 'small' | 'medium' | 'large'
  weight?: keyof typeof theme.ds.typography.weight
  outlined?: boolean
  fullWidth?: boolean
  disabled?: boolean
  noPadding?: boolean
  icon?: React.ReactNode
  iconPosition?: 'left' | 'right' | 'center'
  iconMargin?: string
} & ButtonTypes

const ButtonNew: ForwardRefRenderFunction<S.WrapperProps, ButtonProps> = (
  {
    variant = 'default',
    type,
    size = 'medium',
    weight = 'bold',
    outlined = false,
    fullWidth = false,
    disabled = false,
    noPadding = false,
    icon = false,
    iconPosition = 'left',
    iconMargin = '8px',
    ...props
  }: ButtonProps,
  ref
) => (
  <S.Wrapper
    ref={ref}
    variant={variant}
    type={type}
    size={size}
    weight={weight}
    outlined={outlined}
    fullWidth={fullWidth}
    disabled={disabled}
    noPadding={noPadding}
    {...props}
  >
    {!!icon && (
      <S.Icon iconPosition={iconPosition} iconMargin={iconMargin}>
        {icon}
      </S.Icon>
    )}
    {!!props.children && <span>{props.children}</span>}
  </S.Wrapper>
)

export default forwardRef(ButtonNew)
